import {NetlifyCountry} from "../utils/header-nav";

enum HEADER_LOCALE_LABEL_ENUM {
  US = "English",
  CN = "简体中文",
}

interface HeaderLocale {
  label: HEADER_LOCALE_LABEL_ENUM;
  country: NetlifyCountry;
}

export const HEADER_LOCALES: {items: Array<HeaderLocale>} = {
  items: [
    {
      label: HEADER_LOCALE_LABEL_ENUM.US,
      country: NetlifyCountry.US,
    },
    {
      label: HEADER_LOCALE_LABEL_ENUM.CN,
      country: NetlifyCountry.CN,
    },
  ],
};
